import { node } from "~/util/dom";

export default class Content<Data = any, Options = any> {
	_ec: Array<string>;

	_data: Data;

	_options: Options;

	_dom: {
		container: HTMLDivElement;
		[key: string]: HTMLElement;
	};

	constructor(data: Data, options: Options) {
		this._data = data;
		this._options = {
			...options,
		};
		this._ec = [];
		this._dom = {
			container: node("div"),
		};

		this._build();
	}

	destroy() {
		JAK.Events.removeListeners(this._ec);
	}

	getContainer() {
		return this._dom.container;
	}

	// eslint-disable-next-line class-methods-use-this
	getState() {
		return {};
	}

	_build() {
		this._dom.container.innerHTML = "";
	}
}
